import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {hideBannerAction} from '../../../store/panels/app/banners/bannersActions';
import {AccountsInfoBannerState} from '../../../store/panels/app/banners/bannersState';
import {AppPanelId} from '../../../store/panels/panelStateBase';
import {AccountsInfoBanner} from './accountsInfoBanner';

/*
 * Props.
 */

interface AccountsInfoBannerContainerProps {
  panelId: AppPanelId;
  bannerState: AccountsInfoBannerState;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<AccountsInfoBannerContainerProps>()((props) => ({
  onClose: () => hideBannerAction(props.panelId, props.bannerState.uid),
}));

export const AccountsInfoBannerContainer = connect(null, mapDispatchToProps)(AccountsInfoBanner);
